<template>
    <HelpButton @click="isShowDialog = true" />

    <!-- ヒント用のダイアログ -->
    <HelpDialog :isShow="isShowDialog" @close="isShowDialog = false" title="QualityTraclerとの連携情報について">
        <template v-slot:contents>
            <div>
                <h2>■ワークスペースの確認方法</h2>
                <p>
                    1. QualityTrackerにログインする ※ログインURLはご契約企業様ごとに異なります。<br>
                    2. ドメイン「XXXX.quality-tracker.com」の「XXX」部分を確認する
                </p>
                <img src="@/assets/helps/HowToGetQtWorkSpacepng.png" alt="AnyTestInfo" width="900px">
            </div>
            <div>
                <h2>■APIキーの確認方法</h2>
                <p>
                    1. QualityTrackerにログインする ※ログインURLはご契約企業様ごとに異なります。<br>
                    2. API設定画面を開く<br>
                    3. APIキーを確認する
                </p>
                <img src="@/assets/helps/HowToGetQtAPI.png" alt="AnyTestDevice" width="900px">
            </div>
            <div>
                <h2>■QualityTrackerの連携先プロジェクト名の確認方法</h2>
                <p>
                    1. QualityTrackerにログインする ※ログインURLはご契約企業様ごとに異なります。<br>
                    2. プロダクトを選択する<br>
                    3. プロジェクト一覧メニューからプロジェクト名を確認する
                </p>
                <img src="@/assets/helps/HowToGetQtPj.png" alt="AnyTestDevice" width="900px">
            </div>
        </template>
    </HelpDialog>
</template>
<script>
import { ref } from 'vue'

export default {
    name: 'TestEnvHelp',
    setup() {

        // ###########
        // ダイアログ #
        // ###########
        const isShowDialog = ref(false)
        const updateDialog = (state) => {
            isShowDialog.value = state
        }

        return { updateDialog, isShowDialog }
    }
}
</script>
